import React, { memo, useCallback, useState } from 'react'
import { faCalendar, faShareAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddToCalendarHOC from 'react-add-to-calendar-hoc'
import { useStyles } from './styles'
import CallToActionButton from 'components/common/CallToActionButton/CallToActionButton'
import SharePopover from 'components/common/SharePopover/SharePopover'
import moment from 'moment'
import SimpleDropdown from 'components/common/SimpleDropdown/SimpleDropdown'
import { useSelector } from 'react-redux'
import { getShow } from 'redux/slices/liveShow'

const AddToCalendarDropdown = AddToCalendarHOC(CallToActionButton, props => <SimpleDropdown paper {...props} />)

const InfoBar = () => {
    const classes = useStyles()
    const [shareMenuOpen, setShareMenuOpen] = useState(false)
    const openShare = useCallback(() => setShareMenuOpen(true), [])
    const closeShare = useCallback(() => setShareMenuOpen(false), [])
    const show = useSelector(getShow)

    const artistThumbnail = show.posterImg
    const showTitle = show.title
    const startTime = show.startTime

    const event = {
        description: showTitle,
        duration: '1',
        endDatetime: moment(startTime)
            .utc()
            .add(1, 'hour')
            .format('YYYYMMDDTHHmmssZ'),
        location: `${window.location.protocol}//${window.location.host}${window.location.pathname}`,
        startDatetime: moment(startTime)
            .utc()
            .format('YYYYMMDDTHHmmssZ'),
        title: showTitle,
    }

    return (
        <div className={classes.dashboard}>
            <div className={classes.artistData}>
                <div className={classes.thumbnail} style={{ backgroundImage: `url('${artistThumbnail}')` }} />
                <div className={classes.description}>
                    <h3 className={classes.title}>{showTitle}</h3>
                </div>
            </div>
            <div className={classes.actions}>
                <div id="save-to-cal-btn" className={classes.buttonCointainer}>
                    <AddToCalendarDropdown
                        event={event}
                        buttonProps={{
                            display: 'inline',
                            type: 'tertiary',
                            content: <FontAwesomeIcon className={classes.calendar} icon={faCalendar} />,
                        }}
                    />
                </div>
                <div id="share-btn" className={classes.buttonCointainer}>
                    <CallToActionButton
                        onClick={openShare}
                        display="inline"
                        type="tertiary"
                        content={<FontAwesomeIcon className={classes.calendar} icon={faShareAlt} />}
                    />
                    <SimpleDropdown paper isOpen={shareMenuOpen} onRequestClose={closeShare}>
                        <SharePopover show={show} /> {/*TODO make this component dumber and decouple from show*/}
                    </SimpleDropdown>
                </div>
            </div>
        </div>
    )
}

export default memo(InfoBar)
